define(
  'configResultsCounts',[
    'routes'
  ],
  (
    routes
  ) => {
    'use strict';

    const cache = {};
    const urls =
    {
      amenityResults:
      {
        regex: /\/state\/[a-z-]*\/[a-z-]*/,
        routes: {
          routeResults: routes.getAmenityResults,
          routeCounts: routes.getAmenityCounts
        }
      }
    };

    /**
   * @private
   * urlsToRequestMemoizer: we the url to get the results depending of the location.href
   *
   */
    function urlsToRequestMemoizer(url) {
      const values = Object.values(urls);

      for (let i = 0; i < values.length; i += 1) {
        const value = values[i];
        if (value.regex.test(url)) {
          return value.routes;
        }
      }

      return {
        routeResults: routes.getResults,
        routeCounts: routes.getCounts
      };
    }

    /**
   * @public
   * urlsToRequest: we the url to get the results depending of the location.href
   *
   */
    function urlsToRequest() {
      const url = window.location.href.toLowerCase();
      const value = cache[url] || urlsToRequestMemoizer(url);

      if (value && !cache[url]) {
        cache[url] = value;
      }

      return value;
    }

    return {
      getUrls: urlsToRequest
    };
  }
);

